import { useContext, useState } from "react";
import { AuthContext } from "../context/auth-context";

import PoshLogo from "./UI/PoshLogo";
import poshBkg from "../assets/img/posh-bg.webp";

export default function LoginPage() {
  const { login, error } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState("");

  const formHandler = (event) => {
    event.preventDefault();
    const email = event.target.email.value;
    const password = event.target.password.value;
    
    // Clear previous email error
    setEmailError("");
    
    // Check if email ends with @poshcars.io
    if (email.endsWith("@poshcars.io")) {
      login(email, password);
    } else {
      setEmailError("Access denied. Only @poshcars.io email addresses are allowed.");
    }
  };

  return (
    <div className="grid h-screen bg-gradient-to-br from-stone-900">
      <img
        className="fixed top-0 left-0 object-cover w-screen h-screen -z-10"
        src={poshBkg}
      />
      <div className="flex items-end self-start p-6 space-x-4">
        <PoshLogo />
        <p className="text-2xl md:text-3xl font-extralight text-stone-400">
          Admin
        </p>
      </div>

      <div className="grid justify-center gap-8 p-8 m-auto rounded-lg shadow-lg bg-stone-900 w-96 h-fit">
        <form onSubmit={formHandler} className="grid gap-4">
          <div>
            <label className="text-stone-400">Email: </label>
            <input
              className="w-full form-input"
              name="email"
              type="email"
              required
            />
          </div>
          <div>
            <label className="text-stone-400">Password: </label>
            <input
              className="w-full form-input"
              name="password"
              type={showPassword ? "text" : "password"}
              required
            />

            <p
              onClick={() => setShowPassword(!showPassword)}
              className="mt-1 text-xs text-right cursor-pointer text-stone-400 hover:underline"
            >
              {showPassword ? (
                <span>Hide Password</span>
              ) : (
                <span>Show Password</span>
              )}
            </p>
          </div>
          <div className="grid h-16">
            <button type="submit" className="w-full mt-1 btn-primary">
              Sign In
            </button>
            {emailError && (
              <p className="text-sm text-center text-red-600">{emailError}</p>
            )}
            {error && (
              <p className="text-sm text-center text-red-600">{error}</p>
            )}
          </div>
        </form>
      </div>

      <div className="grid self-end p-4 text-center shadow-lg lg:grid-cols-2">
        
      </div>
    </div>
  );
}
